import type { ActiveFilterChip } from './activeFilters';

/** The scope visible in the reader's filter strip, carried into a Lens question. */
export function lensReaderFilterSummary(
  chips: ReadonlyArray<ActiveFilterChip>,
): Array<{ label: string; value: string }> {
  return chips.map(({ label, value }) => ({ label, value }));
}
